export default __webpack_public_path__ + "static/media/image_31-903.60032d0f.png";